export enum ActiveReturnRebalancingType {
  NO_REBALANCING = 'No Rebalancing',
  DAILY = 'Daily Rebalancing',
  MONTHLY = 'Monthly Rebalancing',
  QUARTERLY = 'Quarterly Rebalancing',
  YEARLY = 'Yearly Rebalancing',
}
